import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';
import { selectSpaceInfoItem } from '~src/spacesPlatform/selectors/SpaceInfoSelectors';
import { hasExtractRefreshPermission } from '~src/spacesPlatform/utils/MixedContentHelpers';

import { AppState } from '../../app/state/AppState';
import { Messages } from '../../codegen/Localize';
import { IDatasourceActions } from '../../datasource/ServerApi/types/IDatasourceActions';
import { IExtractTaskInfo } from '../../ts/models/IExtractTaskInfo';
import { IWorkbookActions } from '../../workbook/ServerApi/types/IWorkbookActions';
import { changeExtractRefreshSchedule } from '../actions/ChangeExtractRefreshScheduleAction';

export const ChangeExtractRefreshScheduleEntityAction:
    IEntityAction<IExtractTaskInfo, IWorkbookActions | IDatasourceActions> = {
  name: EntityActionNames.TasksChangeSchedule,
  translateName: Messages.changeFrequency_action,
  isVisible: () => true,
  isClickable: isClickable,
  createReduxAction: changeExtractRefreshSchedule
};

function isClickable(
  availableActions: IWorkbookActions | IDatasourceActions,
  tasks: IExtractTaskInfo[],
  state: AppState
): boolean {
  const spaceItem = selectSpaceInfoItem(state);
  return hasExtractRefreshPermission(state, spaceItem, availableActions);
}
